import HttpService from "./HttpService";

let sondagemInfantilService = {
  getAll: (anoLetivo, anoEscolar, nomeAluno, raAluno, turma, size, page) => {
    return HttpService.backApi.get(`avaliacao-infantil?anoLetivo=${anoLetivo}&anoEscolar=${anoEscolar}&nomeAluno=${nomeAluno}&raAluno=${raAluno}&turma=${turma}&size=${size}&page=${page}`);
  },

  deletarAluno: (id) => {
    return HttpService.backApi.delete(`avaliacao-infantil/${id}`);
  },

  baixarArquivo: (id) => {
    return HttpService.backApi.get(`avaliacao-infantil/download/${id}`);
  },

  cadastrarSondagem: (id, anoLetivo, anoEscolar, turma, arquivo) => {
    let formData = new FormData();
    formData.append('arquivo', arquivo);

    return HttpService.backApi.post(`avaliacao-infantil?alunoId=${id}&anoLetivo=${anoLetivo}&anoEscolar=${anoEscolar}&turma=${turma}`, formData);
  }
}

export default sondagemInfantilService;